import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMtrComponent } from './simple-icons-mtr.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMtrComponent ],
    exports:      [ SimpleIconsMtrComponent ],
    bootstrap:    []
})
export class SimpleIconsMtrModule {}
